import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/accessibility.css";
import "./styles/mobile.css";
import "./styles/app-shell.css";
import "./styles/homepage.css";
import "./styles/transaction-command-center-readonly.css";
import "./styles/transaction-checklist-phases.css";
import "./styles/transactions-mobile-selector.css";
import "./styles/release-2b-intake.css";
import "./styles/release-2b-home-recovery.css";
import "./styles/release-2b-marketing.css";
import "./styles/release-2b1-primary-client.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
